import { getWeekIdentifier } from '../../../lib/dates';

export default function getTimeplanUnitsByWeek(timeplanUnits) {
  return timeplanUnits.groupBy(timeplanUnit => getWeekIdentifier(timeplanUnit.get('date')));
}
